const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'faces',
  tiles: {
    boss: 0,
    brownkobold: 1,
    calm: 2,
    capedeagle: 3,
    cyclops3: 4,
    healer2: 5,
    icelady: 6,
    ifrit: 7,
    littlesahagin: 8,
    mageslime2: 9,
    nebulan: 10,
    nebulan2: 11,
    nilo: 12,
    phoenix: 13,
    pinkslimev2: 14,
    purpledemon: 15,
    reddemonblue: 16,
    redmonster: 17,
    sahagin: 18,
    sawserpent: 19,
    slug: 20,
    spiderlady: 21,
    steelslime: 22,
    stonegolem: 23,
    succubus: 24,
    thief: 25,
    treegolem: 26,
    turtle2: 27,
    wizardblack: 28,
    yanfly: 29
  },
  uidata: {
    rects: [
      vec4(8/1024,8/128,50/1024,40/128),
      vec4(66/1024,8/128,108/1024,40/128),
      vec4(124/1024,8/128,166/1024,40/128),
      vec4(182/1024,8/128,224/1024,40/128),
      vec4(240/1024,8/128,282/1024,40/128),
      vec4(298/1024,8/128,340/1024,40/128),
      vec4(356/1024,8/128,398/1024,40/128),
      vec4(414/1024,8/128,456/1024,40/128),
      vec4(472/1024,8/128,514/1024,40/128),
      vec4(530/1024,8/128,572/1024,40/128),
      vec4(588/1024,8/128,630/1024,40/128),
      vec4(646/1024,8/128,688/1024,40/128),
      vec4(704/1024,8/128,746/1024,40/128),
      vec4(762/1024,8/128,804/1024,40/128),
      vec4(820/1024,8/128,862/1024,40/128),
      vec4(878/1024,8/128,920/1024,40/128),
      vec4(936/1024,8/128,978/1024,40/128),
      vec4(8/1024,56/128,50/1024,88/128),
      vec4(66/1024,56/128,108/1024,88/128),
      vec4(124/1024,56/128,166/1024,88/128),
      vec4(182/1024,56/128,224/1024,88/128),
      vec4(240/1024,56/128,282/1024,88/128),
      vec4(298/1024,56/128,340/1024,88/128),
      vec4(356/1024,56/128,398/1024,88/128),
      vec4(414/1024,56/128,456/1024,88/128),
      vec4(472/1024,56/128,514/1024,88/128),
      vec4(530/1024,56/128,572/1024,88/128),
      vec4(588/1024,56/128,630/1024,88/128),
      vec4(646/1024,56/128,688/1024,88/128),
      vec4(704/1024,56/128,746/1024,88/128)
    ],
    aspect: [
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125, 1.3125, 1.3125,
      1.3125, 1.3125
    ]
  },
  FRAME_BOSS: 0,
  FRAME_BROWNKOBOLD: 1,
  FRAME_CALM: 2,
  FRAME_CAPEDEAGLE: 3,
  FRAME_CYCLOPS3: 4,
  FRAME_HEALER2: 5,
  FRAME_ICELADY: 6,
  FRAME_IFRIT: 7,
  FRAME_LITTLESAHAGIN: 8,
  FRAME_MAGESLIME2: 9,
  FRAME_NEBULAN: 10,
  FRAME_NEBULAN2: 11,
  FRAME_NILO: 12,
  FRAME_PHOENIX: 13,
  FRAME_PINKSLIMEV2: 14,
  FRAME_PURPLEDEMON: 15,
  FRAME_REDDEMONBLUE: 16,
  FRAME_REDMONSTER: 17,
  FRAME_SAHAGIN: 18,
  FRAME_SAWSERPENT: 19,
  FRAME_SLUG: 20,
  FRAME_SPIDERLADY: 21,
  FRAME_STEELSLIME: 22,
  FRAME_STONEGOLEM: 23,
  FRAME_SUCCUBUS: 24,
  FRAME_THIEF: 25,
  FRAME_TREEGOLEM: 26,
  FRAME_TURTLE2: 27,
  FRAME_WIZARDBLACK: 28,
  FRAME_YANFLY: 29
};
spritesheetRegister(module.exports);
